import { c as _c } from "react/compiler-runtime";
import DragIcon from '@precis-digital/kurama/icons/DragIcon';
import { styled } from '@precis-digital/kurama/utils';
import type { ReactElement } from 'react';
import { Z_INDEX } from '../constants';
import type { CellAlignment, HeaderLabelData } from '../types';
interface TableHeadCellDragPreviewProps {
  data: HeaderLabelData;
  width: number;
  textAlign: CellAlignment;
}
const TableHeadCellDragPreview = t0 => {
  const $ = _c(5);
  const {
    data: t1
  } = t0;
  const {
    width,
    textAlign,
    element
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DragIcon width={24} height={24} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== element || $[2] !== textAlign || $[3] !== width) {
    t3 = <StyledDragPreview width={width} $textAlign={textAlign}>{t2}{element}</StyledDragPreview>;
    $[1] = element;
    $[2] = textAlign;
    $[3] = width;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const StyledDragPreview = styled('div')<{
  width?: number;
  $textAlign?: CellAlignment;
}>(({
  theme,
  width,
  $textAlign: textAlign
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: textAlign === 'left' ? 'flex-start' : 'space-between',
  gap: theme.spacing(1),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: theme.tokens.background.main.default,
  borderRadius: theme.borderRadius.xxSmall,
  border: `1px solid ${theme.tokens.background.tonal.soft.default}`,
  boxShadow: `0 6px 12px 0 ${theme.tokens.background.tonal.soft.default}`,
  width,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: 14,
  cursor: 'grabbing',
  zIndex: Z_INDEX.head + 20
}));
export default TableHeadCellDragPreview;